import React from 'react';
import './JsonPanel.scss';
import {
    NotificationType,
    ToolbarIcon,
} from '@instinet-analytics/semantic-ui-components';
import useCopy from '@react-hook/copy';
import { useDispatchShowNotification } from 'notification/store/dispatcher';
import { JSONTree } from 'react-json-tree';
import classNames from 'classnames';

export interface JsonPanelProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any;
    className?: string;
    title?: string;
}

export default function JsonPanel(props: JsonPanelProps) {
    const { data, className, title } = props;
    const showNotification = useDispatchShowNotification();

    const { copy } = useCopy(safeStringify(data));

    const onClick = () => {
        copy().then(() => {
            showNotification('Copied to clipboard', NotificationType.Info);
        });
    };

    const cssClasses = classNames('JsonPanel', className);

    return (
        <div className={cssClasses}>
            {title && <div className="title">{title}</div>}
            <JSONTree data={data} />
            <ToolbarIcon
                name="clipboard outline"
                active={true}
                onClick={onClick}
            />
        </div>
    );
}

function safeStringify(data: unknown) {
    const cache: unknown[] = [];
    return JSON.stringify(data, function (key, value) {
        if (typeof value === 'object' && value !== null) {
            if (cache.indexOf(value) !== -1) {
                // Circular reference found, discard key
                return;
            }
            // Store value in our collection
            cache.push(value);
        }
        return value;
    });
}
